var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMdAndroid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#95cf00;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1_stroke",
    "data-name": "1 stroke"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Android"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.25,
    y: 4.99,
    width: 39.5,
    height: 39.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Android-2",
    "data-name": "Android",
    className: "cls-2",
    d: "M39.93,17.48a2.33,2.33,0,0,0-2.36,2.3v9.81a2.36,2.36,0,0,0,4.71,0V19.78A2.32,2.32,0,0,0,39.93,17.48Zm-29.86,0a2.32,2.32,0,0,0-2.35,2.3v9.81a2.36,2.36,0,0,0,4.71,0V19.78A2.33,2.33,0,0,0,10.07,17.48Zm4.1,0H14V34.31a2.46,2.46,0,0,0,2.49,2.42h1.8a1.89,1.89,0,0,0-.1.63v4.85a2.36,2.36,0,0,0,4.72,0V37.36a2.19,2.19,0,0,0-.1-.63h4.38a2.18,2.18,0,0,0-.09.63v4.85a2.36,2.36,0,0,0,4.71,0V37.36a1.89,1.89,0,0,0-.1-.63h1.8A2.46,2.46,0,0,0,36,34.31V17.48ZM30.41,8.3l.44-.64L31.29,7l1-1.43a.38.38,0,0,0-.11-.53.39.39,0,0,0-.54.11l-1.5,2.17L29.67,8a13.4,13.4,0,0,0-9.34,0l-.45-.66-.44-.64L18.39,5.17a.4.4,0,0,0-.55-.11.38.38,0,0,0-.11.53l1,1.43.44.64.44.64C16.26,9.81,14,12.68,14,16H36C36,12.68,33.74,9.81,30.41,8.3ZM20.29,12.9a1.15,1.15,0,1,1,1.18-1.15A1.17,1.17,0,0,1,20.29,12.9Zm9.42,0a1.15,1.15,0,1,1,1.18-1.15A1.17,1.17,0,0,1,29.71,12.9Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMdAndroid);
export default __webpack_public_path__ + "static/media/Icon-MD-Android.c505a5fba22a334050deb98935b7652a.svg";
export { ForwardRef as ReactComponent };